// New scenarios for checking understanding after each learning module.
import { analysisReview } from "./analysisReview";
import { productsReview } from "./productsReview";
import { methodsReview } from "./methodsReview";
import { marketsReview } from "./marketsReview";
import { riskReview } from "./riskReview";
import { behaviorReview } from "./behaviorReview";
import { executionReview } from "./executionReview";
import { researchReview } from "./researchReview";
import { householdReviews } from "./householdReviews";
export const moduleReviews = [
  ...householdReviews,
  researchReview,
  analysisReview,
  productsReview,
  methodsReview,
  marketsReview,
  riskReview,
  behaviorReview,
  executionReview,
  {
    moduleId: 'foundation', title: '把生活收支放進同一張圖',
    questions: [
      {
        id: 'foundation-transfer', lessonId: 'cash-flow',
        question: '小禾把自己銀行帳戶的 3,000 元領到錢包，當天沒有其他收支。整體個人收支應如何記錄？',
        options: ['增加 3,000 元收入', '記成帳戶間轉帳，整體收入與支出都不因此增加', '增加 3,000 元生活支出'], answer: 1,
        explanation: '銀行少 3,000 元、錢包多 3,000 元，只是位置改變。若當收入或支出，就會扭曲整體收支。',
      },
      {
        id: 'foundation-reserve-gap', lessonId: 'emergency-fund',
        question: '自行設定的預備金目標為 96,000 元，目前已有 36,000 元，每月可再存 5,000 元。假設期間不動用且不計利息，多久補足？',
        options: ['約 19 個月', '約 7 個月', '12 個月'], answer: 2,
        explanation: '先算缺口 96,000 − 36,000 = 60,000 元，再除以每月 5,000 元，得到 12 個月。這是既定目標的計算，不代表該金額適合所有人。',
      },
      {
        id: 'foundation-deadline', lessonId: 'financial-goals',
        question: '一筆學費四個月後確定要繳，存款卻還有缺口。朋友建議改投資波動大的商品「拚一下」，最合理的下一步是？',
        options: ['重新檢查能存多少、可調整支出與其他資金安排', '因為期限短，所以應承擔更高波動', '把預期獲利當成已存到的學費'], answer: 0,
        explanation: '確定且接近的付款期限，承受不了隨時可能發生的虧損。先修正收支與資金計畫，而非把不確定的市場收益算成確定資金。',
      },
      {
        id: 'foundation-new-loan', lessonId: 'balance-sheet',
        question: '原本資產 180,000 元、負債 40,000 元。新借款 20,000 元全數存入銀行，暫不計任何費用或利息，此刻淨資產是多少？',
        options: ['160,000 元', '140,000 元', '200,000 元'], answer: 1,
        explanation: '資產變成 200,000 元，負債也增加到 60,000 元；200,000 − 60,000 = 140,000 元。借款讓現金增加，但沒有自動創造淨資產。',
      },
    ],
  },
  {
    moduleId: 'numbers', title: '換一組數字，仍能算清楚',
    questions: [
      {
        id: 'numbers-real-return', lessonId: 'compound-inflation',
        question: '某年名目報酬 6%、同期通膨 3%，忽略費用與稅，調整購買力後的實質報酬最接近多少？',
        options: ['9%', '6%', '2.91%'], answer: 2,
        explanation: '1.06 ÷ 1.03 − 1 ≈ 2.91%。直接相減得到 3% 是近似值，精確計算要除以物價變動後的倍數。',
      },
      {
        id: 'numbers-all-in-return', lessonId: 'total-return',
        question: '期初投入 20,000 元，期末持股市值 19,000 元，另領現金配息 1,200 元未再投入；尚須扣除且未反映於前述數字的費用共 200 元。沒有其他現金流，總報酬率是多少？',
        options: ['0%', '6%', '−5%'], answer: 0,
        explanation: '（19,000 + 1,200 − 200 − 20,000）÷ 20,000 = 0%。價格損失、現金配息與未扣費用需合併計算；已反映的費用則不能重複扣。',
      },
      {
        id: 'numbers-three-year-cagr', lessonId: 'annualized-return',
        question: '沒有中途投入或提領，10,000 元三年後變成 13,310 元。複合年化報酬是多少？',
        options: ['約 11.03%', '10%', '33.1%'], answer: 1,
        explanation: '1.1 × 1.1 × 1.1 = 1.331，所以複合年化為 10%。33.1% 是三年累計報酬；年化只是等效平均，不代表每年真的都漲 10%。',
      },
      {
        id: 'numbers-peak-reference', lessonId: 'risk-drawdown',
        question: '某投資從期初 100 元漲到 150 元高點，再降到 120 元，期間沒有其他現金流。此刻相對高點的回撤幅度與相對期初的累計報酬分別是？',
        options: ['回撤 30%，累計報酬 20%', '回撤 20%，累計報酬 −20%', '回撤 20%，累計報酬 20%'], answer: 2,
        explanation: '回撤幅度看高點：（150 − 120）÷ 150 = 20%；累計報酬看期初：（120 − 100）÷ 100 = 20%。兩者參考點不同，可以同時成立。',
      },
    ],
  },
  {
    moduleId: 'stocks', title: '把報價、圖表與交易分開判讀',
    questions: [
      {
        id: 'stocks-wick-reading', lessonId: 'candlesticks',
        question: '一根日 K 開盤 120、最高 126、最低 116、收盤 118 元，依本課台灣常見配色，哪個判讀正確？',
        options: ['綠 K，下影線長度為 2 元', '紅 K，下影線長度為 4 元', '綠 K，上影線長度為 8 元'], answer: 0,
        explanation: '收盤 118 低於開盤 120，因此為綠 K。實體下端是 118，下影線為 118 − 116 = 2 元；上影線則為 126 − 120 = 6 元。',
      },
      {
        id: 'stocks-moving-window', lessonId: 'volume-moving-average',
        question: '依時間先後，最近六個交易日收盤價為 30、33、36、39、42、45 元。以每日收盤價計算簡單 MA5，最後一天數值是多少？',
        options: ['37.5 元', '39 元', '45 元'], answer: 1,
        explanation: '只取最近五筆，移除最舊的 30 元：（33 + 36 + 39 + 42 + 45）÷ 5 = 39 元。六筆平均 37.5 元不是 MA5。',
      },
      {
        id: 'stocks-earnings-denominator', lessonId: 'eps-pe',
        question: '假想股票價格維持 90 元，用來比較的全年 EPS 從 6 元變成 3 元。兩個口徑下的本益比分別是多少？',
        options: ['15 倍、15 倍', '30 倍、15 倍', '15 倍、30 倍'], answer: 2,
        explanation: '90 ÷ 6 = 15 倍，90 ÷ 3 = 30 倍。價格不變，盈餘分母改變仍會改變本益比；這並未保證未來股價或獲利。',
      },
      {
        id: 'stocks-partial-fill', lessonId: 'order-liquidity',
        question: '買進委託顯示「送出成功」，成交回報卻只有原委託數量的一半。假設沒有其他交易，應如何理解？',
        options: ['目前只確認一半成交，還要查看未成交餘額與委託狀態', '送出成功代表剩下的一半已保證成交', '這表示全部成交，回報只是顯示比較慢'], answer: 0,
        explanation: '持股變化應依實際成交回報判斷。剩餘委託可能仍在等待，也可能受委託條件等影響，不能自行當成已成交。',
      },
    ],
  },
  {
    moduleId: 'funds', title: '看清商品之外的價格與成本',
    questions: [
      {
        id: 'funds-premium-calculation', lessonId: 'etf-nav',
        question: '假設同一時點、相同幣別且可比較的 ETF 每單位淨值為 24 元，市價為 25.2 元，這代表什麼？',
        options: ['折價 5%', '溢價 5%', '未來保證上漲 5%'], answer: 1,
        explanation: '（25.2 − 24）÷ 24 = 5%，市價高於淨值，所以是溢價。這個價差不是預告之後會賺多少。',
      },
      {
        id: 'funds-bond-two-risks', lessonId: 'bond-basics',
        question: '某固定利率債券的發行人按時付款，但市場要求的殖利率上升。只考慮這項變化，哪個判斷較合理？',
        options: ['發行人按時付款，所以債券市價不會變', '市價下跌就證明發行人已經違約', '債券市價可能下降，這與是否違約是不同風險'], answer: 2,
        explanation: '信用風險關注約定款項能否支付；利率風險則會影響定息債券的市價。發行人沒有違約，也不表示中途出售價格固定。',
      },
      {
        id: 'funds-fee-amount', lessonId: 'fund-fees',
        question: '為了單純練習，假設平均資產額整年固定為 300,000 元，只計一項年費用率 0.6%，估計一年費用是多少？',
        options: ['1,800 元', '180 元', '18,000 元'], answer: 0,
        explanation: '0.6% = 0.006；300,000 × 0.006 = 1,800 元。真實金額要按資產變動與基金收費規則計算，並核對是否還有其他成本。',
      },
      {
        id: 'funds-combined-fx', lessonId: 'overseas-fx',
        question: '以 1 美元＝32 台幣買入 1,000 美元資產，之後資產增加 10%，期末匯率變成 1 美元＝28.8 台幣。忽略費用與稅，也沒有中途現金流，台幣報酬為何？',
        options: ['0%', '−1%', '10%'], answer: 1,
        explanation: '期初 32,000 台幣；期末 1,100 × 28.8 = 31,680 台幣。31,680 ÷ 32,000 − 1 = −1%；兩個 10% 因計算基礎不同，不會直接抵銷。',
      },
    ],
  },
  {
    moduleId: 'strategy', title: '讓規則適合真實的資金需求',
    questions: [
      {
        id: 'strategy-average-cost', lessonId: 'diversification',
        question: '兩次各投入 1,500 元，價格分別為每單位 30 元與 50 元，忽略費用。全部買入後，平均每單位成本是多少？',
        options: ['40 元', '30 元', '37.5 元'], answer: 2,
        explanation: '分別買到 50 與 30 單位，共 80 單位；3,000 ÷ 80 = 37.5 元。不能把兩次價格直接平均，因為兩次買到的數量不同。',
      },
      {
        id: 'strategy-capacity-change', lessonId: 'asset-allocation',
        question: '小廷原本每月收入穩定，現在準備離職進修，接下來一年會用到更多存款。他仍不害怕股市下跌，是否就不必重新檢查配置？',
        options: ['仍應檢查，因為用錢時間與財務承受能力已改變', '不必，心理上不怕虧損就夠了', '不必，只要年齡沒變就維持相同比例'], answer: 0,
        explanation: '心理意願與實際支付能力要分開看。收入與支出時間改變，可能讓原配置不再符合資金需求，即使情緒上仍能接受波動。',
      },
      {
        id: 'strategy-new-cash-rebalance', lessonId: 'rebalancing',
        question: '純計算練習：股票市值 60,000 元、債券 40,000 元，既定目標為各占 50%。若不賣出、只把新資金加到債券，忽略成本與價格變化，要增加多少？',
        options: ['10,000 元', '20,000 元', '40,000 元'], answer: 1,
        explanation: '增加 20,000 元後，股票與債券各 60,000 元，總額 120,000 元，各占 50%。新增資金會同時改變分子與總額；此比例僅供練習。',
      },
      {
        id: 'strategy-withdrawal-sequence', lessonId: 'retirement-planning',
        question: '兩個退休組合起始金額相同，每年年底都提領同額生活費。一組先跌再漲，另一組先漲再跌；兩年的漲跌率只是對調順序，能保證期末餘額相同嗎？',
        options: ['能，平均報酬一樣就一定一樣', '能，只要每次提領金額相同', '不能，提款後留在市場中的本金會受報酬順序影響'], answer: 2,
        explanation: '提款會改變下一期參與漲跌的本金，因此有現金流時，報酬順序會影響結果。只看平均報酬，無法充分評估退休提領風險。',
      },
    ],
  },
  {
    moduleId: 'practice', title: '把判斷用在真實資訊情境',
    questions: [
      {
        id: 'practice-small-withdrawal', lessonId: 'costs-and-fraud',
        question: '陌生投資平台曾讓你成功小額提領，現在要求先匯一筆「解鎖費」才能領回大額資金，並催你今天付款。應如何處理？',
        options: ['停止新增付款、保存紀錄，透過自行找到的官方管道查證', '小額領過就已證明可靠，立刻付款', '向朋友借款補足解鎖費'], answer: 0,
        explanation: '小額成功提領不是平台可靠的證明。追加付款與催促出金的情境需要停止並查證，不應為領回原款而繼續投入。',
      },
      {
        id: 'practice-plan-review', lessonId: 'investment-plan',
        question: '你事先安排的投資計畫檢查日到了，目標與收入沒有改變，也沒有發現新問題。哪個做法符合「定期檢查」的意思？',
        options: ['一定要換掉一個商品，才算有執行計畫', '完成核對並記錄結果，沒有調整理由時也可以不交易', '保證接下來半年不會虧損'], answer: 1,
        explanation: '檢查是核對目標、餘裕與風險，並不強迫當天進行交易；記錄「目前無須調整」也是有依據的結果。',
      },
      {
        id: 'practice-confirming-evidence', lessonId: 'investor-bias',
        question: '小恩買入後，只收藏看好該公司的文章，遇到反對意見就跳過。最值得先改善的是哪一步？',
        options: ['增加更多看好文章，讓自己更有信心', '立刻做出相反交易，不必研究', '把支持與反對證據都列出，分清事實、推論與未知'], answer: 2,
        explanation: '選擇性閱讀容易漏掉重要資訊。檢查反對證據不代表必須反向交易，而是讓判斷有更完整的依據。',
      },
      {
        id: 'practice-repost-source', lessonId: 'information-check',
        question: '五個社群帳號都貼出同一張沒有日期的獲利截圖，且都指向同一篇貼文。這能當成五個獨立來源互相證實嗎？',
        options: ['不能，仍須回查原始文件、日期與計算方式', '可以，轉貼次數越多就越準確', '可以，只要圖上的百分比相同'], answer: 0,
        explanation: '同一內容被轉貼，不會自動變成獨立查證。日期、期間、幣別與是否扣費等缺漏，仍需找到原始資料確認。',
      },
    ],
  },
];
